import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
} from "react";
import { useNavigate } from "react-router-dom";
import "./DilemaResultBeforePayment.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import DilemaCards from "../DilemaCards/DilemaCards";
import DilemaUniques from "../DilemaUniques/DilemaUniques";
import { useParams } from "react-router-dom";
import axios from "axios";
import { END_URL, IMG_URL, SITE_URL } from "../../config";
import loadimg from "../../images/pp-logo.gif";
import Subscriptions from "../Subscriptions/Subscriptions";
import PopupOne from "../PopupOne/PopupOne";
import fire from "../../images/fire.svg";
import wt from "../../images/white-lock.svg";
import pt from "../../images/lock-purple.svg";
import DilemaBarGraph from "../DilemaBarGraph/DilemaBarGraph";
import SideModalOne from "../SideModalOne/SideModalOne";
import SharePopup from "../ResultChart/SharePopup";

export default function DilemaResultBeforePayment({
  admin,
  globaltest,
  userdetail,
  onLoginChange,
  free
}) {
  const contentRefs = useRef([]);

  const [ShowModal, setShowModal] = useState(false);

  const subS = true;

  const [subscription, setSubscription] = useState(null);

  const [SubPayment, setSubPayment] = useState([]);

  const [PopupContent, setPopupContent] = useState([]);

  const [testlink, settestlink] = useState("");

  const [ReportContent, setReportContent] = useState([]);

  const [DilemmaTop, setDilemmaTop] = useState([]);

  const [GraphData, setGraphData] = useState([]);

  const [DilemmaSlug, setDilemmaSlug] = useState("");

  const handleMile = (value) => {
    setMile(value);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const handleSub = async (subJson) => {
    try {
      let subIds = [];

      if (typeof subJson === "string") {
        try {
          subIds = JSON.parse(subJson);
        } catch (e) {
          console.error("Invalid JSON string for subIds:", e);
          return;
        }
      } else if (Array.isArray(subJson)) {
        subIds = subJson;
      }

      setShowModal(true);

      const res = await axios.post(
        `${END_URL}/sub_adver_dilemma`,
        { ids: subIds },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setSubscription(res.data);
    } catch (err) {
      console.error("Error loading subscriptions:", err);
    }
  };

  const HandlePayment = (item) => {
    const InitializePayment = async () => {
      try {
        const pay_url = "test-payment";

        const response = await fetch(`${END_URL}/${pay_url}`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },

          body: JSON.stringify(item),
        });

        const data = await response.json();

        console.log(data.payment, "fetch data");

        if (data.payment) {
          window.location.href = data.payment;
        } else {
          console.error("Invalid response:", data);
          alert("An error occurred while processing the request.");
        }
      } catch (error) {
        console.error("Error sending result:", error);
      }
    };

    InitializePayment();
  };

  const { slug } = useParams();

  const [IsAdmin, setIsAdmin] = useState(admin);

  const [Ispaid, setIsPaid] = useState(free ? true : false);  

  const [testData, settestData] = useState([]);

  const [Result, setResult] = useState("");

  const [Demension, setDemension] = useState([]);

  const token = localStorage.getItem("token");

  const navigate = useNavigate();

  const user = localStorage.getItem("user");

  const [Subcription, setSubcription] = useState([]);

  const [resultReady, setResultReady] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  const [resultDetails, setResultDetails] = useState([]);

  const [Dilemma, setDilemma] = useState([]);

  const [ArcheType, setArcheType] = useState([]);

  const [DilemmaTypes, setDilemmaTypes] = useState([]);

  const [UserResult, setUserResult] = useState([]);

  const [mile, setMile] = useState(true);

  const [SubId, setSubId] = useState([]);

  const [InfoSub, setInfoSub] = useState(false);

  // const HandleButton = () => {
  //   if (!mile) {
  //     setInfoSub(true);
  //   } else {
  //     navigate(`/result/dilemma/${slug}`);
  //   }
  // };

  useEffect(() => {
    FetchResultData();
  }, []);

  const FetchResultData = async () => {

    const url = Ispaid ? "admin-dilemma-free" : "result-deliemmas";

    try {
      const response = await fetch(`${END_URL}/${url}/${slug}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          admin: IsAdmin ? true : false,
          paid: Ispaid ? true : false,
        }),
      });

      const data = await response.json();

      setDilemma(data.dilemma);

      setArcheType(data?.arche_type);

      settestlink(data?.test_link);

      setReportContent(data?.report_contents);

      setDilemmaTypes(data?.dilemma_types);

      setUserResult(data?.user_result);

      setMile(data?.subcription);

      setSubId(data?.sub_ids);

      setSubPayment(data?.subcription_data);

      setPopupContent(data?.popup_content);

      setDilemmaTop(data?.dilemma_top);

      setGraphData(data?.graph_data);

      setDilemmaSlug(data?.dilemma_test_slug);
    } catch (error) {
      console.error("Error sending result:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (
      Dilemma &&
      typeof Dilemma === "object" &&
      Object.keys(Dilemma).length > 0
    ) {
      setResultReady(true);
    }
  }, [Dilemma]);

  const testsubscription = testData?.test?.type;

  const typetest =
    testsubscription === "free_test" ? "type_1" : testsubscription;

  const subplan = Subcription?.data?.filter((item) => {
    return item.type === typetest;
  });

  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const [copied, setCopied] = useState(false);
  const [isSharePopupOpen, setIsSharePopupOpen] = useState(false);

  const handleShare = () => {
    setIsSharePopupOpen(true);
  };

  const dilemma_name = Dilemma?.name;

  const dilemma_slug = dilemma_name
    ? dilemma_name
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-")
        .replace(/[^\w\-]+/g, "")
        .replace(/\-\-+/g, "-")
        .replace(/^-+/, "")
        .replace(/-+$/, "")
    : "";

  const shareUrl = `${IMG_URL}/view-image-result/${Dilemma?.id}/${dilemma_slug}?v=${Dilemma?.version}`;

  const filename = Dilemma?.share_image?.split("/").pop() || "";

  const shareImg = `${Dilemma?.share_image}`;

  const shareTitle = Dilemma?.name || "Dilemma";
  const shareText = `${Dilemma?.name || "Dilemma"} result!`;

  const dataReady = !isLoading && resultReady;

  const showNormalLoader = !dataReady;

  if (showNormalLoader) {
    return (
      <div className="loader-container">
        <img src={loadimg} alt="Loading..." className="loader-gif" />
      </div>
    );
  }

  return (
    <>
      <div
        className="test-main dilresult-cont dilresult-cont-unpaid"
        // style={{
        //     background: `url(${IMG_URL}/d0/${Dilemma.banner_image}) no-repeat center center`,
        //     backgroundSize: "cover",
        //   }}
      >
        <div className="col-md-12 dil-res-prev-banner">
          <div>
            <img src={`${IMG_URL}/d0/${Dilemma.banner_image}`} alt="" />
          </div>
        </div>

        <div
          className="dilema-unlock-banner"
          style={{
            backgroundImage: `url(${IMG_URL}/d0/${Dilemma?.sub_banner_image})`,
            backgroundSize: "cover",
            backgroundPosition: "relative",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="dilema-unlock-btn">
            <p
              className="dilema-free-title"
              dangerouslySetInnerHTML={{
                __html: PopupContent?.dilemma_free_result_main_title,
              }}
            />

            <a
              onClick={() => {
                handleSub(SubId);
              }}
              class="continue-btn new-commom-btn"
            >
              <span>{PopupContent?.dilemma_free_result_button}</span>

              <span class="righ-arr">
                <FontAwesomeIcon icon={faArrowRight} />
              </span>
            </a>

            {PopupContent?.dilemma_free_result_title && (
              <p>{PopupContent?.dilemma_free_result_title}</p>
            )}
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className={`dilema-cards-in-result`}>
                <DilemaCards
                  testlink={testlink}
                  Dilemma={Dilemma}
                  ArcheType={ArcheType}
                  DilemmaTypes={DilemmaTypes}
                  UserResult={UserResult}
                  infoContent={PopupContent?.dilemma_arche_type_info}
                  DilemmaSlug={DilemmaSlug}
                  TierBreak={PopupContent?.traits_breakdown_text}
                  DilemmaShare={PopupContent?.dilemma_share_button}
                />

                <div className="flex items-center space-x-2 dilemma-share-image mobile-share">
                  <button className="button freereul" onClick={handleShare}>
                    {PopupContent?.dilemma_share_button || " Share Result"}
                    <span>
                      <FontAwesomeIcon className="icc" icon={faArrowRight} />
                    </span>
                  </button>

                  {copied && (
                    <span className="ml-2 text-green-500 text-sm font-medium">
                      Link copied!
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row dilema-sub-cards">
            <div className="dilema-outer-box">
              <div className="dilema-inner-box">
                <div className="col-md-4">
                  <div className="dile-box">
                    <div
                      className="dile-box-title"
                      dangerouslySetInnerHTML={{
                        __html: PopupContent?.dilemma_heat_map,
                      }}
                    />

                    <div className="dile-box-li">
                      <ul>
                        {DilemmaTop &&
                          DilemmaTop?.length > 0 &&
                          DilemmaTop?.map((item, index) => {

                            const fireCount = 3 - index;

                            return (
                                <li
                                  key={index}
                                  className={index > 0 ? "lock-test" : ""}
                      
                                >
                                  <span>{item.category_name}</span>

                                  <span className="img-for-dilema-res">
                                    {" "}
                                    <img src={`${IMG_URL}/d0/${item.icon}`} />
                                  </span>

                                  <div>
                                    
                                     {[...Array(fireCount)].map((_, index) => (
                                      <img key={index} src={fire} alt="" />
                                    ))}

                                    {index > 0 && (
                                      <span className="none-blur">
                                        <img src={wt} alt="" />
                                      </span>
                                    )}
                                  </div>
                                </li>
                              );
                          })}
                      </ul>
                    </div>

                    <a
                      onClick={() => {
                        handleSub(SubId);
                      }}
                      class="continue-btn new-commom-btn"
                    >
                      <span>{PopupContent?.dilemma_free_result_button}</span>

                      <span class="righ-arr">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </span>
                    </a>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="dile-box">
                    <div
                      className="dile-box-title"
                      dangerouslySetInnerHTML={{
                        __html: PopupContent?.instinct_speed_profile,
                      }}
                    />

              
                    <div className="dile-box-li">
                      <ul>
                        {DilemmaTop &&
                          DilemmaTop?.length > 0 &&
                          DilemmaTop?.map((item, i)  => {

                          let label = "";

                          let image_link = "";

                          if (i === 0) {
                            label = "Fastest decision:";
                            image_link = `${IMG_URL}/d0/${PopupContent.fastest_icon_image}`;
                          } else if (i === 1) {
                            label = "Average decision:";
                            image_link = `${IMG_URL}/d0/${PopupContent.average_icon_image}`;
                          } else if (i === 2) {
                            label = "Slowest decision:";
                            image_link = `${IMG_URL}/d0/${PopupContent.slowest_icon_image}`;
                          }

                          return (
                              <li
                                key={i}
                                className={i > 0 ? "lock-test" : ""}
                  
                              >
                                {/* <span className="dilema-Question-hover">You stay focused on goals, prioritizing outcomes over emotions or distractions</span> */}
                                <span>{label} {item?.time_taken}s</span>

                                <span className="img-for-dilema-res">
                                  {" "}
                                  <img src={image_link} />
                                </span>

                                <div>
                               
                                  {i > 0 && (
                                    <span className="none-blur">
                                      <img src={wt} alt="" />
                                    </span>
                                  )}
                                </div>
                              </li>
                            );
                          })}
                          
                      </ul>
                    </div>

                    <a
                      onClick={() => {
                        handleSub(SubId);
                      }}
                      class="continue-btn new-commom-btn"
                    >
                      <span>{PopupContent?.dilemma_free_result_button}</span>

                      <span class="righ-arr">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </span>
                    </a>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="dile-box barchart-div">
                    <div
                      className="dile-box-title"
                      dangerouslySetInnerHTML={{
                        __html: PopupContent?.decision_finger_print,
                      }}
                    />

                    {GraphData && GraphData.length > 0 && (

                      <div className="diema-barchart-call lock-class-added">

                          <DilemaBarGraph graph_data={GraphData} blur={true} />

                          <a
                            onClick={() => {
                              handleSub(SubId);
                            }}
                          >
                            <img src={wt} alt="" />
                          </a>
                      </div>

                    )}

                    <a
                      onClick={() => {
                        handleSub(SubId);
                      }}
                      class="continue-btn new-commom-btn"
                    >
                      <span>{PopupContent?.dilemma_free_result_button}</span>

                      <span class="righ-arr">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row dilema-key">
            <div className="dielma-key-outer">
              <div className="dielma-key-inner">
                <h2>{PopupContent?.dilemma_key_title}</h2>

                <DilemaUniques DilemmaTypes={DilemmaTypes} />
              </div>
            </div>
          </div>

          <div className="row dilema-blur ">
            <div className="blur-outer active-blur">
              <div className="blur-inner">
                <a className="blur-cont-a">
                  <SideModalOne
                    token={token}
                    buttonlabel={PopupContent?.blur_content_button}
                    free_test_sub_modal={SubId}
                    handleSub={handleSub}
                    onLoginChange={onLoginChange}
                  />
                </a>

                <p>{PopupContent?.dilemma_free_result_blur}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {InfoSub && (
        <PopupOne
          PopupContent={PopupContent}
          SubId={SubId}
          handleSub={handleSub}
          handleMile={handleMile}
          HandlePayment={HandlePayment}
          SubPayment={SubPayment}
        />
      )}

      {ShowModal && (
        <div
          className={`newdashpop-overlay subs-cognit-modal1 modal_subcript dilemmanshow ${subscription?.data?.length == 1 ? "single-subscription" : ""}`}
        >
          <div className="newdashpop-inner">
            <div className="newdashpop-container">
              <button
                className="newdashpop-close"
                // onClick={() => {
                //   setShowModal(false);
                //   setMile(false);
                // }}
                onClick={() => setShowModal(false)}
              >
                &times;
              </button>

              <div className="conent-pop">
                <Subscriptions
                  subs={subS}
                  userdetail={{ ...userdetail, user_all_access: "0" }}
                  force_to_disable={false}
                  Subcription={subscription}
                  onLoginChange={onLoginChange}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <SharePopup
        isOpen={isSharePopupOpen}
        onClose={() => setIsSharePopupOpen(false)}
        shareUrl={shareUrl}
        shareImg={shareImg}
        shareTitle={shareTitle}
        shareText={shareText}
        TestUrl={`${SITE_URL}/dilemma/${DilemmaSlug}`}
        filename={filename}
      />
    </>
  );
}
